let controller1 = new ScrollMagic.Controller();

//secton2 
var box2_title=document.getElementsByClassName('box2_title');
let scene2 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.box2', 
        triggerHook: "onenter",
        duration:0,
})
scene2.on("progress", function (event) {
    box2_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box2_title[0].classList.remove("showup");
    }
})

//secton2_1
var box2_title=document.getElementsByClassName('box2_title');
let scene2_1 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Mbox2', 
        triggerHook: "onenter",
        duration:0,
})
scene2_1.on("progress", function (event) {
    box2_title[1].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box2_title[1].classList.remove("showup");
    }
})

//secton3 
let scene3 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.box3', 
        triggerHook: "onenter",
        duration:0,
})
scene3.on("progress", function (event) {
    var i = 0;
    var flag;
    function start(){
        flag =  setInterval(zhuan,1)
    }
    start()
    function zhuan(){
        i++;
        $('.box3_img').css({transform:'rotate('+i+'deg)',transition:'none'})
        if(i==360){
            clearInterval(flag)
        }
    }

    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        clearInterval(flag)
    }
})

//secton4
var box4_left=document.getElementsByClassName('box4_left');
var box4_right=document.getElementsByClassName('box4_right');
let scene4 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box4', 
    triggerHook: "onenter",
    duration:0,
})
scene4.on("progress", function (event) {
    box4_left[1].classList.add("showup");
    box4_right[1].classList.add("showup");
    var z = 11;
    var flag2;
    function start2(){
        flag2 =  setInterval(zhuan2,1000)
    }
    start2()
    function zhuan2(){
        z++;
        $('.box4_btn1').css({animation:'move 1s infinite'})
        document.getElementsByClassName('box4_num')[0].innerHTML = z
        if(z==15){
            z=10
        }
    }
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        clearInterval(flag2)
        box4_left[1].classList.remove("showup");
        box4_right[1].classList.remove("showup");
    }
})


var box4_left=document.getElementsByClassName('box4_left');
var box4_right=document.getElementsByClassName('box4_right');
let scene4_1 = new ScrollMagic.Scene({
    offset: 300,
    triggerElement: '.box4', 
    triggerHook: "onenter",
    duration:0,
})
scene4_1.on("progress", function (event) {
    box4_left[0].classList.add("showup");
    box4_right[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box4_left[0].classList.remove("showup");
        box4_right[0].classList.remove("showup");
    }
})

//secton5
var box5_title=document.getElementsByClassName('box5_title');
var box5_img=document.getElementsByClassName('box5_img');
let scene5 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box5', 
    triggerHook: "onenter",
    duration:0,
})
scene5.on("progress", function (event) {
    box5_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box5_title[0].classList.remove("showup");
        box5_img[0].classList.remove('rollIn')
    }
})

let scene5_1 = new ScrollMagic.Scene({
    offset: 100,
    triggerElement: '.box5', 
    triggerHook: "onenter",
    duration:0,
})
scene5_1.on("progress", function (event) {
    box5_img[0].classList.add('rollIn')
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
    }
})

//section5 mobile
let scene5_2 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.Mbox5', 
    triggerHook: "onenter",
    duration:0,
})
scene5_2.on("progress", function (event) {
    box5_title[1].classList.add("showup");
    box5_img[1].classList.add('rollIn')
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box5_title[1].classList.remove("showup");
        box5_img[1].classList.remove('rollIn')
    }
})

//secton6
var box6_title=document.getElementsByClassName('box6_title');
let scene6 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box6', 
    triggerHook: "onenter",
    duration:0,
})
scene6.on("progress", function (event) {
    box6_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    
    if(index1<2){
        box6_title[0].classList.remove("showup");
        $('.box6_num').html('99')
        $('.box6_icon1').show()
        $('.box6_icon2').hide()
        $('.box6_icon3').hide()
    }else{
        function mask(){
            $('.box6_icon2').show()
            $('.box6_icon3').hide()
            $('.box6_icon1').hide()
        }
        setTimeout(mask,1000)
        function Nomask(){
            $('.box6_num').html('15')
            $('.box6_icon3').show()
            $('.box6_icon1').hide()
            $('.box6_icon2').hide()
        }
        setTimeout(Nomask,2000)
        function Nomask1(){
            $('.box6_num').html('99')
            $('.box6_icon3').hide()
            $('.box6_icon1').show()
            $('.box6_icon2').hide()
        }
        setTimeout(Nomask1,3000)
    }
})

//secton7
var box7_title=document.getElementsByClassName('box7_title');
var box7_img=document.getElementsByClassName('box7_img');
let scene7 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box7', 
    triggerHook: "onenter",
    duration:0,
})
scene7.on("progress", function (event) {
    box7_title[0].classList.add("showup");
    box7_title[1].classList.add("showup");
    box7_img[0].style.animation = 'move7 2s infinite';
    box7_img[1].style.animation = 'move7m 2s infinite';
    $('.light1').css({animation:'move7_2 2s infinite'})
    $('.light2').css({animation:'move7_1 2s infinite'})
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box7_title[0].classList.remove("showup");
        box7_title[1].classList.remove("showup");
        box7_img[0].style.animation = 'none'
        box7_img[1].style.animation = 'none'
        $('.light1').css({animation:'none'})
        $('.light2').css({animation:'none'})
    }
})

//secton8
var box8_title=document.getElementsByClassName('box8_title');
let scene8 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box8', 
    triggerHook: "onenter",
    duration:0,
})
scene8.on("progress", function (event) {
    box8_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box8_title[0].classList.remove("showup");
    }
})

//secton9
var box9_title=document.getElementsByClassName('box9_title');
let scene9 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box9', 
    triggerHook: "onenter",
    duration:0,
})
scene9.on("progress", function (event) {
    box9_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box9_title[0].classList.remove("showup");
    }
})

//secton10
var box10_title=document.getElementsByClassName('box10_title');
let scene10 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box10', 
    triggerHook: "onenter",
    duration:0,
})
scene10.on("progress", function (event) {
    box10_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box10_title[0].classList.remove("showup");
    }
})

//secton11
var box11_title=document.getElementsByClassName('box11_title');
var box11_text=document.getElementsByClassName('box11_text');
let scene11 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box11', 
    triggerHook: "onenter",
    duration:0,
})
scene11.on("progress", function (event) {
    box11_title[0].classList.add("showup");
    box11_text[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box11_title[0].classList.remove("showup");
        box11_text[0].classList.remove("showup");
    }
})

controller1.addScene([scene2,scene3,scene2_1,scene4,scene4_1,scene5,scene5_1,scene6,scene5_2,scene7,scene8,scene9,scene10,scene11]); 


$(window).scroll(function(){
    var top = $(window).scrollTop();
    var top2 = top/window.innerWidth*100
    var dom = document.getElementsByClassName('Mban5')
    var top4 = dom[0].getBoundingClientRect().top
    var dom2 = document.getElementsByClassName('box6')
    var top3 = dom2[0].getBoundingClientRect().top
    //console.log(top3)
    //console.log(top4)
    //console.log(top2)
    if(top2>48.5){
        $('.ban2').css({position:'fixed',inset:'50px auto auto 0px'})
    }
    if(top2>192.5){
        $('.ban5').css({position:'fixed',inset:'85px auto auto 0px'})
    }
    if(top2<192.5||top2>260){
        $('.ban5').css({position:'relative',inset:'0px auto auto 0px'})
    }
    if(top2<48||top2>120){
        $('.ban2').css({position:'relative',inset:'0px auto auto 0px'})
    }
    if(top2>140){
        $('.Mban2').css({position:'fixed',inset:'112px auto auto 0px'})
    }
    if(top2<140||top2>460){
        $('.Mban2').css({position:'relative',inset:'0px auto auto 0px'})
    }
    if(top4<122){
        $('.Mban5').css({position:'fixed',inset:'112px auto auto 0px'})
    }
    if(top3<100||top3>756){
        $('.Mban5').css({position:'relative',inset:'0px auto auto 0px'})
    }
})

var r8se6aswiper = new Swiper('.r8se6aswiper', {
    slidesPerView : 3,
    spaceBetween : '2%',
    loop:true,
    navigation: {
        nextEl: '.s6swiper-button-next',
        prevEl: '.s6swiper-button-prev',
    },
    pagination: {
        el: '.r8s6img',
        clickable: true,
        renderBullet: function (index, className) {
        switch(index){
            case 0:color='#d10032';break;
            case 1:color='#882ece';break;
            case 2:color='#e3290c';break;
            case 3:color='#eb2f48';break;
            case 4:color='#2fd9b9';break;
            case 5:color='#ff2cb5';break;
            case 6:color='#fa922d';break;
            case 7:color='#882dd0';break;
            case 8:color='#ec2e48';break;
            case 9:color='#3057fa';break;
            case 10:color='#fc00d0';break;
            case 11:color='#bbf800';break;
            case 12:color='#19d800';break;
            case 13:color='#12fc00';break;
            case 14:color='#ef00f8';break;
            case 15:color='#ad0000';break;
        }
        return '<span class="' + className + '" style="background:'+color+'"></span>';
        },
    },
})

var Mr8se6aswiper = new Swiper('.Mr8se6aswiper', {
    slidesPerView : 1.5,
    spaceBetween : '8%',
    loop:true,
    centeredSlides: true,
    pagination: {
        el: '.Mr8s6img',
        clickable: true,
        renderBullet: function (index, className) {
        switch(index){
            case 0:color='#d10032';break;
            case 1:color='#882ece';break;
            case 2:color='#e3290c';break;
            case 3:color='#eb2f48';break;
            case 4:color='#2fd9b9';break;
            case 5:color='#ff2cb5';break;
            case 6:color='#fa922d';break;
            case 7:color='#882dd0';break;
            case 8:color='#ec2e48';break;
            case 9:color='#3057fa';break;
            case 10:color='#fc00d0';break;
            case 11:color='#bbf800';break;
            case 12:color='#19d800';break;
            case 13:color='#12fc00';break;
            case 14:color='#ef00f8';break;
            case 15:color='#ad0000';break;
        }
        return '<span class="' + className + '" style="background:'+color+'"></span>';
        },
    },
})


const allIcons = document.querySelectorAll('.page_section9 .glide__bullet');


// event listeners
allIcons.forEach(el =>{
    el.addEventListener('mouseenter', ()=>{
        el.closest(".glide__bullet").click();
    });
});
new Glide('.glide1',{
    type: 'carousel',
    perView: 3,
    focusAt: 'center',
    autoplay: 2000,
    gap:0,
    breakpoints: {
        800: {
        perView: 2
        },
        400: {
        perView: 1
        }
    }
}).mount();


